export default [
  {
    path: '/sales/demo',
    name: 'demo',
    component: () => import('@/views/painel/demo.vue'),
  },
]
